import { array, boolean, nullable, number, optional, record, string, type, union, unknown } from 'superstruct';
export const CartItemDiscount = unknown();
export const CartItemFeaturedImage = type({
    url: nullable(string()),
    alt: nullable(string()),
    width: nullable(number()),
    height: nullable(number()),
    aspect_ratio: nullable(number())
});
export const CartItemProperties = record(string(), nullable(union([
    number(),
    string(),
    array(optional(nullable(union([
        number(),
        string()
    ]))))
])));
export const OptionWithValue = type({
    name: string(),
    value: string()
});
export const LineLevelDiscountAllocation = unknown();
export const CartItem = type({
    key: string(),
    id: number(),
    properties: nullable(CartItemProperties),
    quantity: number(),
    variant_id: number(),
    title: nullable(string()),
    price: number(),
    original_price: number(),
    discounted_price: number(),
    line_price: number(),
    original_line_price: number(),
    total_discount: number(),
    discounts: array(CartItemDiscount),
    sku: nullable(string()),
    grams: number(),
    vendor: nullable(string()),
    taxable: nullable(boolean()),
    product_id: nullable(number()),
    product_has_only_default_variant: boolean(),
    gift_card: boolean(),
    final_price: number(),
    final_line_price: number(),
    url: string(),
    featured_image: CartItemFeaturedImage,
    handle: nullable(string()),
    requires_shipping: nullable(boolean()),
    product_type: nullable(string()),
    product_title: nullable(string()),
    product_description: nullable(string()),
    variant_title: nullable(string()),
    variant_options: nullable(array(string())),
    options_with_values: nullable(array(OptionWithValue)),
    line_level_discount_allocations: array(LineLevelDiscountAllocation),
    line_level_total_discount: number()
});
